import { Box, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

export function FrBirthname() {
  const { company } = useCurrentSession()

  const mainCountry = company.legalEntities.find((legalEntity) => legalEntity.main)?.country

  if (mainCountry !== 'fr') return null

  return (
    <Box gap="s4">
      <Text.Normal size="200" weight="medium" color="grey1000">
        {i18n.t('employee_form.birth_name')}
      </Text.Normal>
      <Box
        background="grey000White"
        padding="s16"
        borderRadius={{ all: 'abs008' }}
        border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
      >
        <Box padding="s4"></Box>
      </Box>
    </Box>
  )
}
